var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<img" + (jade.attr("src", require('./../tip-lightbulb-copy-3.svg'), true, true)) + " width=\"55\" alt=\"\"><br><br><div style=\"width: 240px;\"><h3>Use \"Applicants\" to view submitted applications and reports</h3></div><div class=\"dots\"><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('intro-step1')\" class=\"dot dot1-button\"></a><a href=\"#\" class=\"dot dot2-button active\"></a><a href=\"#\" onClick=\"window.Shepherd.activeTour.show('intro-step3')\" class=\"dot dot3-button\"></a></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/forms/tour/intro/step2.jade
// module id = 773
// module chunks = 0